module.exports = __webpack_public_path__ + "static/4i-e652470b9572b86907b77a97f40dc915.woff";